var map = {
	"./en/card_2_2.png": "ux6w",
	"./es/card_2_2.png": "xdy/",
	"./pt/card_2_2.png": "RsKR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gWRy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/card_2_2\.png$
// module id = gWRy
// module chunks = 0